module.exports = __webpack_public_path__ + "static/p2040037-685341ba20349bf7eb75c6e45896643d.jpg";